import {CardObject, LinkObject} from '../../shared/connector-message';
import {CommunityMember} from '../../shared/CommunityMember';

export interface ElementLock {
  lockType: ElementLockType;
  userId: string;
  linkObject?: LinkObject;
  cardObject?: CardObject;
  communityMember: CommunityMember;
}

export enum ElementLockType {
  LOCK_CARD = 'LOCK_CARD',
  LOCK_LINK = 'LOCK_LINK',
  LOCK_SOURCE_TARGET_CARD = 'LOCK_SOURCE_TARGET_CARD'
}
